import InputField from "@/components/InputField";
import defaultValues from "@/constant/defaultValues";
import { isEmpty, map, size, trim } from "lodash";
import Select from "react-select";

const AirFreight = (props) => {
  const { TERM_LIST, PACKAGING_TYPE } = defaultValues;

  const {
    errors,
    styleError,
    formData,
    handleFocusOut,
    handleChange,
    handleCountryFromChange,
    handleCountryToChange,
    handleTermChange,
    showPickupAddress,
    showDeliveryAddress,
    countries,
    selectedTerm,
    selectedCountryFrom,
    selectedCountryTo,
    handleFieldAddClick,
    handleFieldRemoveClick,
    handleLQPChange,
    handleLQPcbppChange,
    handleLQPFocusOut,
  } = props;

  return (
    <>
      <div className="col-sm-6"></div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Origin Country</label>
          <div className="input-pad">
            <Select
              name="country_from"
              options={countries}
              value={selectedCountryFrom}
              onChange={handleCountryFromChange}
              placeholder="Select origin country"
              className="dd-pad"
              onBlur={handleFocusOut}
              noOptionsMessage={() => "No Country Found"}
            />
            {errors.country_from && (
              <span className="company-required" style={styleError}>
                {errors.country_from}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Origin airport </label>
          <div className="input-pad">
            <InputField
              type="text"
              name="port_of_origin"
              value={formData.port_of_origin}
              // className="form-control"
              autoComplete="off"
              placeholder={`Enter origin airport`}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.port_of_origin && (
              <span className="company-required" style={styleError}>
                {errors.port_of_origin}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Destination Country</label>
          <div className="input-pad">
            <Select
              name="country_to"
              options={countries}
              value={selectedCountryTo}
              onChange={handleCountryToChange}
              placeholder="Select destination country"
              className="dd-pad"
              noOptionsMessage={() => "No Country Found"}
              onBlur={handleFocusOut}
            />
            {errors.country_to && (
              <span className="company-required" style={styleError}>
                {errors.country_to}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">
            Destination airport
          </label>
          <div className="input-pad">
            <InputField
              type="text"
              name="port_of_destination"
              value={formData.port_of_destination}
              // className="form-control"
              autoComplete="off"
              placeholder={`Enter destination airport`}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.port_of_destination && (
              <span className="company-required" style={styleError}>
                {errors.port_of_destination}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Commodity/Product</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="commodity"
              value={formData.commodity}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter commodity/product"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.commodity && (
              <span className="company-required" style={styleError}>
                {errors.commodity}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">HS Code</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="hs_code"
              value={formData.hs_code}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter hs code"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.hs_code && (
              <span className="company-required" style={styleError}>
                {errors.hs_code}
              </span>
            )}
          </div>
        </div>
      </div>
      {map(formData.lwh_qty_packaging, (lqp, indx) => {
        const rowError = errors.lwh_qty_packaging?.[indx] || {};

        return (
          <div className="row" key={indx}>
            <div className="col-sm-5">
              <div className="input-group">
                <label className="form-label required">
                  Length/Width/Height (CM)
                </label>
                <div className="input-pad">
                  <InputField
                    type="text"
                    name="lwh"
                    value={trim(lqp.lwh)}
                    // className="form-control"
                    autoComplete="off"
                    placeholder="Enter Length/Width/Height (CM)"
                    onChange={(e) => handleLQPChange(e, "lwh", indx)}
                    onBlur={() => handleLQPFocusOut(indx, "lwh")}
                  />
                  {rowError.lwh && (
                    <span className="company-required" style={styleError}>
                      {rowError.lwh}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="input-group">
                <label className="form-label required">No / Qty</label>
                <div className="input-pad ">
                  <InputField
                    type="text"
                    name="no_qty"
                    value={trim(lqp.no_qty)}
                    className="input"
                    autoComplete="off"
                    placeholder="No / Qty"
                    onChange={(e) => handleLQPChange(e, "no_qty", indx)}
                    onBlur={() => handleLQPFocusOut(indx, "no_qty")}
                  />
                  {rowError.no_qty && (
                    <span className="company-required" style={styleError}>
                      {rowError.no_qty}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="input-group">
                <label className="form-label required">Select Type of Packaging</label>
                <div className="input-pad">
                  <Select
                    name="cbpp"
                    options={PACKAGING_TYPE}
                    value={
                      PACKAGING_TYPE.find((opt) => opt.value === lqp.cbpp) ||
                      null
                    }
                    onChange={(selectedOption) =>
                      handleLQPcbppChange(selectedOption, "cbpp", indx)
                    }
                    placeholder="Select Type of Packaging"
                    className="dd-pad"
                    // onBlur={handleFocusOut}
                    noOptionsMessage={() => "No packaging type Found"}
                  />
                  {rowError.cbpp && (
                    <span className="company-required" style={styleError}>
                      {rowError.cbpp}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-1 d-lg-flex align-items-start flex-shrink-0">
              <div className="d-flex align-items-center mt-4 outline-btns">
                <div className="d-flex gap-1">
                  {indx == size(formData.lwh_qty_packaging) - 1 && (
                    <div className="btn outline" onClick={handleFieldAddClick}>
                      <i className="fa fa-plus"></i>
                    </div>
                  )}

                  {size(formData.lwh_qty_packaging) > 1 && (
                    <div
                      className="btn outline"
                      onClick={() => handleFieldRemoveClick(indx)}
                    >
                      <i className="fa fa-minus"></i>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">Total Weight (KG)</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="total_weight"
              value={formData.total_weight}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter Total Weight (KG)"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />

            {errors.total_weight && (
              <span className="company-required" style={styleError}>
                {errors.total_weight}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Term</label>
          <div className="input-pad">
            <Select
              name="term"
              options={TERM_LIST}
              value={selectedTerm}
              onChange={handleTermChange}
              placeholder="Select ocean type"
              className="dd-pad"
              noOptionsMessage={() => "No Term Found"}
              onBlur={handleFocusOut}
            />

            {errors.term && (
              <span className="company-required" style={styleError}>
                {errors.term}
              </span>
            )}
          </div>
        </div>
      </div>

      {selectedTerm &&
        !isEmpty(selectedTerm) &&
        showPickupAddress.includes(selectedTerm.value) && (
          <div className="col-sm-6 ">
            <div className="input-group">
              <label className="form-label required">Pickup Address</label>
              <div className="input-pad">
                <InputField
                  type="text"
                  name="pickup_address"
                  value={formData.pickup_address}
                  // className="form-control"
                  autoComplete="off"
                  placeholder="Enter pickup address"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                {errors.pickup_address && (
                  <span className="company-required" style={styleError}>
                    {errors.pickup_address}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}

      {selectedTerm &&
        !isEmpty(selectedTerm) &&
        showDeliveryAddress.includes(selectedTerm.value) && (
          <div className="col-sm-6 ">
            <div className="input-group">
              <label className="form-label required">Delivery Address</label>
              <div className="input-pad">
                <InputField
                  type="text"
                  name="delivery_address"
                  value={formData.delivery_address}
                  // className="form-control"
                  autoComplete="off"
                  placeholder="Enter delivery address"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                {errors.delivery_address && (
                  <span className="company-required" style={styleError}>
                    {errors.delivery_address}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default AirFreight;
